'use client';

import { memo } from 'react';
import { Typography, Button } from '../../kit';
import { themeColors } from '../../theme/theme';
import { Box, Stack } from '@mui/material';
import { RocketLaunch } from '@mui/icons-material';
import { commonStyles, animations } from '../../styles/shared/commonStyles';
import { useTranslation } from '@/kit/useTranslation';

const NoQuote = memo(({ onGetStarted }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        ...commonStyles.card,
        ...animations.fadeIn,
        background: `linear-gradient(135deg, ${themeColors.backgroundColor} 70%, ${themeColors.primaryColor}11 100%)`,
        p: { xs: 3, sm: 4 },
        my: 3,
        textAlign: 'center',
      }}
    >
      <Stack spacing={3} alignItems="center">
        {/* Modern Icon */}
        <RocketLaunch
          sx={{
            fontSize: { xs: 64, sm: 80 },
            color: themeColors.primaryColor,
            opacity: 0.2,
          }}
        />

        {/* Title */}
        <Box>
          <Typography
            type="h2"
            style={{
              color: themeColors.primaryColor,
              fontWeight: 900,
              fontSize: { xs: 32, sm: 48 },
              lineHeight: 1.2,
              letterSpacing: 1,
              mb: 1,
            }}
            text={t('noQuote.title')}
          />
          <Typography
            type="body1"
            style={{
              color: themeColors.textSecondary,
              fontSize: { xs: 14, sm: 16 },
              maxWidth: 400,
              mx: 'auto',
            }}
            text={t('noQuote.subtitle')}
          />
        </Box>

        {/* CTA */}
        <Button
          variant="contained"
          onClick={onGetStarted}
          sx={{
            background: themeColors.primaryColor,
            color: 'white',
            fontWeight: 700,
            fontSize: { xs: 16, sm: 18 },
            px: { xs: 3, sm: 4 },
            py: { xs: 1.5, sm: 2 },
            borderRadius: 2,
            textTransform: 'none',
            boxShadow: 3,
            '&:hover': {
              boxShadow: 6,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s',
          }}
        >
          {t('noQuote.cta')}
        </Button>
      </Stack>
    </Box>
  );
});

NoQuote.displayName = 'NoQuote';

export default NoQuote;
